export default "SELECT database_id, schema_id, table_id, owner_id, name\n  FROM sys.table\n  WHERE database_id = $(database_id)\n"